import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-06e64760")

_pushScopeId("data-v-06e64760")
const _hoisted_1 = { class: "row animated fadeIn" }
const _hoisted_2 = { class: "col-xl-12 col-lg-12" }
const _hoisted_3 = { class: "card border-left-warning shadow mb-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "card-header py-3 d-flex flex-row align-items-center justify-content-between" }, [
  /*#__PURE__*/_createVNode("h6", { class: "m-0 font-weight-bold" }, "Users List")
], -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-12 col-md-12 col-sm-12 col-12" }
const _hoisted_10 = { class: "custom-input-group mb-3" }
const _hoisted_11 = {
  key: 0,
  class: "input-group-text",
  style: {"border-top-left-radius":"0","border-bottom-left-radius":"0","border-left-width":"0"}
}
const _hoisted_12 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M22,3H7C6.31,3 5.77,3.35 5.41,3.88L0,12L5.41,20.11C5.77,20.64 6.31,21 7,21H22A2,2 0 0,0 24,19V5A2,2 0 0,0 22,3M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12"
  })
], -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-10 col-md-10 col-sm-12 col-12 text-left" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = /*#__PURE__*/_createVNode("button", { class: "btn btn-sm btn-success" }, [
  /*#__PURE__*/_createTextVNode(" Add "),
  /*#__PURE__*/_createVNode("i", {
    class: "fa fa-user-plus",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" No pending users to verify. ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Loading pending users. Please wait. ")
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fas fa-building" }, null, -1)
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "fas fa-male" }, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "badge badge-pill badge-success"
}
const _hoisted_25 = {
  key: 1,
  class: "badge badge-pill badge-secondary"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-success btn-sat-street"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-search" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_DataTable, {
              value: _ctx.getFilteredUsers,
              paginator: true,
              rows: 10,
              rowsPerPageOptions: [10, 20, 50],
              autoLayout: true,
              filterDisplay: "menu",
              loading: _ctx.status == 'fetching',
              paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
              currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
              filters: _ctx.filters,
              "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters = $event)),
              globalFilterFields: ['fullName', 'email', 'createdAt']
            }, {
              header: _withId(() => [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _withDirectives(_createVNode("input", {
                          autofocus: "",
                          type: "text",
                          class: "form-control",
                          placeholder: "Type to search...",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSearchUsers && _ctx.onSearchUsers(...args)))
                        }, null, 544), [
                          [_vModelText, _ctx.filters['global'].value]
                        ]),
                        (!_ctx.filters['global'].value)
                          ? (_openBlock(), _createBlock("span", _hoisted_11, [
                              _hoisted_12
                            ]))
                          : (_openBlock(), _createBlock("span", {
                              key: 1,
                              class: "input-group-text",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearFilter()))
                            }, [
                              _hoisted_13
                            ]))
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.radioOptions, (option) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "form-check form-check-inline",
                          key: option.value
                        }, [
                          _withDirectives(_createVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            id: option.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.radios = $event)),
                            value: option.value
                          }, null, 8, ["id", "value"]), [
                            [_vModelRadio, _ctx.radios]
                          ]),
                          _createVNode("label", {
                            class: "form-check-label",
                            for: option.value
                          }, [
                            _createTextVNode(_toDisplayString(option.text) + " ", 1),
                            _createVNode("i", {
                              class: option.icon
                            }, null, 2)
                          ], 8, ["for"])
                        ]))
                      }), 128))
                    ]),
                    _createVNode("div", _hoisted_16, [
                      _createVNode(_component_router_link, { to: {
                          name: 'dashboard.add.user',
                          params: { customerId: null }
                        } }, {
                        default: _withId(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ])
              ]),
              empty: _withId(() => [
                _hoisted_18
              ]),
              loading: _withId(() => [
                _hoisted_19
              ]),
              default: _withId(() => [
                _createVNode(_component_Column, {
                  field: "email",
                  header: "Email",
                  bodyStyle: "text-align: left"
                }, {
                  body: _withId((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.hideEmail(slotProps.data.email)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Type" }, {
                  body: _withId((slotProps) => [
                    (slotProps.data.corporate)
                      ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_20, [
                          _hoisted_21
                        ], 512)), [
                          [
                            _directive_tooltip,
                            'Business',
                            void 0,
                            { top: true }
                          ]
                        ])
                      : _withDirectives((_openBlock(), _createBlock("span", _hoisted_22, [
                          _hoisted_23
                        ], 512)), [
                          [
                            _directive_tooltip,
                            'Personal',
                            void 0,
                            { top: true }
                          ]
                        ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "firstName",
                  header: "Name",
                  bodyStyle: "text-align: left"
                }),
                _createVNode(_component_Column, {
                  field: "emailConfirmed",
                  header: "Email Confirmed"
                }, {
                  body: _withId((slotProps) => [
                    (slotProps.data.emailConfirmed)
                      ? (_openBlock(), _createBlock("span", _hoisted_24, " Confirmed "))
                      : _createCommentVNode("", true),
                    (!slotProps.data.emailConfirmed)
                      ? (_openBlock(), _createBlock("span", _hoisted_25, " Unconfirmed "))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "createdAt",
                  header: "Created At"
                }, {
                  body: _withId((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.createdAt)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "quantity",
                  header: "Action",
                  colClass: "small"
                }, {
                  body: _withId((slotProps) => [
                    _createVNode(_component_router_link, {
                      to: {
                      name: slotProps.data.corporate
                        ? 'dashboard.company-verify'
                        : 'dashboard.user-verify',
                      params: { id: slotProps.data.id }
                    }
                    }, {
                      default: _withId(() => [
                        _hoisted_26
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "loading", "filters"])
          ])
        ])
      ])
    ])
  ]))
})